<template>
  <div>
    <page-loading v-if="!item" />
    <page-title v-if="item" :title="pageTitle" />
    <allergen-fields :item="item" v-on:submit="onSubmit" v-on:cancel="onCancel" v-if="item">
      <template v-slot:save>Save</template>
    </allergen-fields>
  </div>
</template>

<script>
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'

export default {
  name: "AllergenEdit",
  mixins: [CrudOperationsMixin],
  props: {},
  data() {
    return {
      item: null
    };
  },
  computed: {
    pageTitle: function () {
      return 'Allergen: ' + this.item.name;
    }
  },
  methods: {
    load: function () {

      this.readQuery('/graphql/management', {
          query: `
            query ($id: ID) {
              allergen (id: $id) {
                id,
                concurrencyCheck,
                commonName,
                family,
                name,
                showAtEndOfList,
                imageName,
                category,
                type
              }
            }`,
          variables: {
            'id': this.$route.params.id
          }
        }, (data) => {
          this.item = data.allergen;
        });
    },
    onCancel(evt) {
      this.$router.push('/allergen');
    },
    onSubmit(evt) {
      this.updateQuery('/graphql/management', {
        query: `
          mutation ($id: ID!, $allergen: AllergenUpdateInputOGT!) {
            updateAllergen(id: $id, allergen: $allergen) {
              id,
              name
            }
          }`,
        variables: {
          'id': this.$route.params.id,
          'allergen': this.item
        }}, () => {
          this.$router.push('/allergen');
        }, null, 'Allergen', this.item.name);
    }    
  },
  mounted () {
    this.load();
    // Use this instead of the previous line to test the "Loading" bar
    //window.setTimeout(this.load, 3000);
  }
};
</script>